import { routesBuilder } from '@guiker/shared-framework'

import { RentalInquiry } from '../../../entity'
import { paths } from '../paths'
import { updateUserSchema } from './schemas'

const { buildPut } = routesBuilder<RentalInquiry>()({
  basePath: paths.rentalInquiry.all.base(),
})

export const routes = {
  updateRentalInquiryUserInformation: buildPut({
    path: '/user',
    payloadSchema: updateUserSchema,
  }),
}
